import { render, staticRenderFns } from "./CarrinhoCatalogoConsulta.vue?vue&type=template&id=3f148061&scoped=true"
import script from "./CarrinhoCatalogoConsulta.vue?vue&type=script&lang=js"
export * from "./CarrinhoCatalogoConsulta.vue?vue&type=script&lang=js"
import style0 from "./CarrinhoCatalogoConsulta.vue?vue&type=style&index=0&id=3f148061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f148061",
  null
  
)

export default component.exports